module.exports = __webpack_public_path__ + "static/hire_remote_team_OG@2x-6fc050a3eb325caf59304de25e8875dc.png";